import { Badge } from "@/components/ui/badge";
import { STATUS_LABEL, STATUS_TONE, type DispatchStatus } from "@/hooks/useUpdateDispatchStatus";

interface Props {
  status: string | null | undefined;
  className?: string;
}

export function DispatchStatusBadge({ status, className }: Props) {
  const s = (status as DispatchStatus) || "draft";
  const label = STATUS_LABEL[s] ?? s;
  const tone = STATUS_TONE[s] ?? STATUS_TONE.draft;
  return (
    <Badge variant="outline" className={`${tone} ${className ?? ""}`}>
      {label}
    </Badge>
  );
}
